import { useState } from "react";
import { Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import { useAuth } from "../../providers/AuthProvider";
import Api from "../../utils/api";
import encryptPassword from "../../utils/crypt";

const LoginScreen = ({ onLogin }) => {

    const { updateAuthData } = useAuth();


    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");


    const handleLogin = async () => {
        const pass = await encryptPassword(password)

        const payload = {
            username: username,
            password: pass
        }
        const result = await Api.postLogin('/auth/login', payload)
        if (result.success) {
            updateAuthData(result.token, {})
            onLogin()
        }

    };

    const updateInput = (event) => {
        let { name, value } = event.target;

        if (name === 'username') {
            setUsername(value)
        } else {
            setPassword(value)
        }
    }

    return (



        <Container className="vh-100 justify-content-center align-items-center">

            <Row className="justify-content-center vh-100 align-items-center">
                <Col md={4}>

                    <Card className="shadow p-2 rounded">

                        <Card.Body>
                            <h5 className="card-title text-center mb-4">Acceso</h5>

                            <Form.Group className="mb-3">
                                <Form.Label>Usuario</Form.Label>
                                <Form.Control name="username" defaultValue={username} onChange={updateInput} />
                                <Form.Text className="text-muted">Sin espacios ni caracteres especiales</Form.Text>
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Contraseña</Form.Label>
                                <Form.Control name="user" type="password" defaultValue={password} onChange={updateInput} />
                                <Form.Text className="text-muted">Sin espacios ni caracteres especiales</Form.Text>
                            </Form.Group>

                            <Button className="w-100 mb-3 mt-3" onClick={handleLogin}>Ingresar</Button>

                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}

export default LoginScreen;